const Loader = () => {
  return (
    <>
      <div className="loading-page">
        <div className="corners">
          <div className="corner corner--1"></div>
          <div className="corner corner--2"></div>
          <div className="corner corner--3"></div>
          <div className="corner corner--4"></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
